import { render, staticRenderFns } from "./PanelModalDataEdit.vue?vue&type=template&id=10037714&scoped=true&"
import script from "./PanelModalDataEdit.vue?vue&type=script&lang=js&"
export * from "./PanelModalDataEdit.vue?vue&type=script&lang=js&"
import style0 from "./PanelModalDataEdit.vue?vue&type=style&index=0&id=10037714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10037714",
  null
  
)

export default component.exports